export default "/images/177c1b8724cedd39f80039511f1f182f.avif";